import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  AlertDialog, AlertDialogHeader, AlertDialogBody, Button,
} from '@americanexpress/dls-react';

const DeleteConfirmation = ({ handlePopupShow, showPopup, submitPopLabel }) => {
  if (!showPopup.show) {
    return null;
  }

  const handleClose = () => handlePopupShow(null, null, null, false, '', false);
  const handleConfirm = () => handlePopupShow(
    showPopup.idx,
    showPopup.fileId,
    showPopup.fileName,
    false,
    showPopup.popupType,
    true
  );

  if (showPopup.popupType === 'delete') {
    return (
      <AlertDialog className="text" onClose={handleClose} id="dialog-box-example">
        <AlertDialogHeader className="text pad-4-t" id="dialog-box-header">
          <div className="flex flex-column duak-delete-header-content">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="44" viewBox="0 0 48 44" fill="none" className="duak-delete-warning-icon" aria-hidden="true" focusable="false">
              <path fillRule="evenodd" clipRule="evenodd" d="M26.088 0.513077C23.833 -0.660923 21.071 0.248077 19.918 2.54308L0.504 37.2061L0.387 37.4561C0.131675 38.0486 -1.39664e-05 38.6869 0 39.3321C0 41.9001 2.052 44.0001 4.584 44.0001H43.415L43.687 43.9921C44.321 43.9535 44.9398 43.7818 45.503 43.4881C47.756 42.3141 48.649 39.5011 47.496 37.2061L28.081 2.54308L27.955 2.30908C27.5167 1.54461 26.8689 0.921438 26.088 0.513077ZM22.708 3.72263C23.128 3.05063 23.988 2.80263 24.698 3.17263H24.699C24.987 3.3241 25.22 3.56235 25.365 3.85363L44.832 38.7236L44.892 38.8606C45.1836 39.6064 44.8713 40.4523 44.165 40.8296C43.949 40.9416 43.71 41.0016 43.467 41.0016H4.533L4.393 40.9956C3.612 40.9226 3 40.2516 3 39.4356C3 39.1876 3.058 38.9426 3.168 38.7226L22.708 3.72263ZM24 32.0001C25.1046 32.0001 26 32.8956 26 34.0001C26 35.1047 25.1046 36.0001 24 36.0001C22.8954 36.0001 22 35.1047 22 34.0001C22 32.8956 22.8954 32.0001 24 32.0001ZM24.1567 15.0051L23.9517 15.0001H23.9507L23.7667 15.0131C22.7387 15.1281 21.9607 15.9981 22.0007 17.0181L22.4167 27.5201C22.4497 28.3461 23.1497 29.0001 23.9997 29.0001C24.8497 29.0001 25.5497 28.3461 25.5837 27.5201L26.0007 16.9431L25.9947 16.7911C25.9187 15.8381 25.1367 15.0791 24.1567 15.0051Z" fill="var(--Status-Colors-Status-Warning, #B42C01)" />
            </svg>
            <div className="duak-delete-header-title">
              <FormattedMessage id="deleteDocumentTitle" defaultMessage="Delete document ?" />
            </div>
            <div className="duak-delete-header-body">
              <FormattedMessage
                id="deleteDocumentBody"
                defaultMessage="Document {fileName} will be deleted"
                values={{
                  fileName: showPopup.fileName,
                }}
              />
            </div>
          </div>
        </AlertDialogHeader>
        <AlertDialogBody className="text duak-delete-dialog-body" id="dialog-box-body">
          <div className="duak-delete-body-content">
            <div className="duak-delete-divider-container">
              <div className="duak-delete-divider" aria-hidden="true" />
            </div>
            <div className="duak-delete-button-row">
              <Button
                type="button"
                className="text duak-delete-confirm-button"
                onClick={handleConfirm}
              >
                <span className="text">
                  <FormattedMessage id="deleteButton" />
                </span>
              </Button>
            </div>
            <div className="duak-delete-button-row">
              <Button
                type="button"
                className="text duak-delete-cancel-button"
                onClick={handleClose}
              >
                <span className="text">
                  <FormattedMessage id="cancel" />
                </span>
              </Button>
            </div>
          </div>
        </AlertDialogBody>
      </AlertDialog>
    );
  }

  if (showPopup.popupType === 'submit') {
    return (
      <AlertDialog className="text" onClose={handleClose} id="dialog-box-example">
        <AlertDialogHeader className="text" id="dialog-box-header">
          <p className="pad-1-b">
            <span className="text font-weight-bold">
              <FormattedMessage id="submitDocuments" />
              ?
            </span>
          </p>
        </AlertDialogHeader>
        <AlertDialogBody className="text" id="dialog-box-body">
          <div className="flex flex-column margin-auto-lr pad-2-b delete-confirmation-fixed-width">
            {submitPopLabel}
          </div>
          <div className="flex flex-column">
            <button
              type="button"
              className="btn btn-primary text margin-auto-lr margin-1-b delete-confirmation-fixed-width"
              onClick={handleConfirm}
            >
              <span className="text">
                <FormattedMessage id="submitButton" />
              </span>
            </button>
            <button
              type="button"
              className="btn btn-secondary text margin-auto-lr margin-1-b delete-confirmation-fixed-width"
              onClick={handleClose}
            >
              <span className="text">
                <FormattedMessage id="cancel" />
              </span>
            </button>
          </div>
        </AlertDialogBody>
      </AlertDialog>
    );
  }

  return null;
};

DeleteConfirmation.propTypes = {
  handlePopupShow: PropTypes.func.isRequired,
  showPopup: PropTypes.instanceOf(Object).isRequired,
  submitPopLabel: PropTypes.string.isRequired,
};

export default DeleteConfirmation;
